<div class="member-view">
  <div class="modal-header">
    <div></div>
    <button type="button" class="close" (click)="activeModal.dismiss()">&times;</button>
  </div>

  <div class="modal-body">
    <div class="img"><img src="{{baseURL + image}}" alt="협회지 목차" /></div>
  </div>

  <div class="modal-footer">
    <button class="close-btn" (click)="activeModal.dismiss()">닫기</button>
  </div>
</div>